import { Checkbox, Tooltip } from "@material-ui/core";
import { ITableColumn } from "components/interfaces";
import { useState } from "react";
import { CollapsibleRow } from "../../../UI/Table";
import { TypographyOverflow } from "../../../UI/Typographies";

const CheckBoxSub = ({ checked = false, onChange, ...props }) => {
  const [selected, setSelected] = useState(checked);

  const handleChange = (ev) => {
    setSelected(!selected);
    onChange(ev);
  };

  return <Checkbox {...props} checked={selected} onChange={handleChange} />;
};

interface IProps {
  row: any;
  columns: ITableColumn[];
  subColumns: ITableColumn[];
  onChangeCheck: (
    rowId: string,
    installmentId: number,
    checked: boolean
  ) => void;
  page?: string;
}

const InstallmentRowLink = ({
  row,
  columns,
  subColumns,
  onChangeCheck,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelect] = useState(false);

  const handleClickCollapse = () => setOpen(!open);

  const handleChange = () => {
    setSelect(!selected);
    handleClickCollapse();
  };

  const handleChangeCheck = (installmentNumber) => (ev) => {
    onChangeCheck(row.id, installmentNumber, ev.target.checked);
  };

  const subTableRows = row.installments.map((installment, index) => {
    let custom: any = {
      checked: installment.initialCheck?.checked || false,
      disabled: installment.initialCheck?.disabled || false,
    };

    if (index === 0) custom.style = { marginLeft: "1rem" };

    installment.input = (
      <CheckBoxSub
        {...custom}
        color="primary"
        onChange={handleChangeCheck(installment.id)}
      />
    );
    return installment;
  });

  row.input = (
    <Checkbox checked={selected} onChange={handleChange} color="primary" />
  );

  const title = (
    <div style={{ width: 150 }}>
      <Tooltip title={row.title} arrow>
        <TypographyOverflow>{row.title}</TypographyOverflow>
      </Tooltip>
    </div>
  );

  return (
    <CollapsibleRow
      open={open}
      columns={columns}
      subColumns={subColumns}
      row={{ ...row, title }}
      rowDetails={subTableRows}
      subColumnLength={columns.length}
      blankColumns={0}
    />
  );
};

export default InstallmentRowLink;
